<template>
  <div class="wl-ad-list">
    <el-select :value="myValue"
               filterable
               :multiple="multi"
               remote
               :collapse-tags="collapseTags"
               reserve-keyword
               clearable
               @change="onValueChange"
               @clear="onClear"
               :placeholder="$t('TABLE_HEADER_EMAIL_StaffName')"
               :remote-method="callStack"
               :class="['wl-ad-select', showAdd? 'has-right-btn' : 'no-right-btn', size==='mini' ? 'mini':'small']"
               :loading="loading"
               :disabled="selectDisabled"
    >
      <el-option v-for="(item, k) in options"
                 :key="k"
                 :label="item.label"
                 :value="item.email">
      </el-option>
    </el-select>
    <el-button v-if="showAdd"
               class="wl-green"
               icon="el-icon-plus"
               @click="addAccount"
               :disabled="disabled">{{$t('COMMON_ADD')}}
    </el-button>
  </div>
</template>
<script>
  import * as _ from 'lodash'

  export default {
    data() {
      return {
        options: [],
        initOptions: [],
        myValue: this.value,
        loading: false,
        multi: _.isArray(this.value)
      }
    },
    methods: {
      async remoteMethod(query) {
        try {
          const {code, data, errDetails} = await this.api({searchContent: query})
          if (code !== '1') throw new Error(errDetails)
          return Promise.resolve(data.records)
        } catch (e) {
          return Promise.reject([])
        }
      },
      async callStack(args, type) {
        if (args === '') return

        this.loading = true

        if (typeof args === 'string') {
          args = [args]
        }

        const combineArr = arr => _.reduce(arr, (prev, curr) => _.concat(prev, curr), [])

        const filterNullData = arr => _.filter(arr, v => v)

        const mapFilter = _.curry((filter, arr) => _.map(arr, this.filter))

        const rs = await Promise.all(_.map(args, v => this.remoteMethod(v)))
        const dataProducer = _.flow(
          combineArr,
          filterNullData,
          mapFilter(this.filter)
        )

        if (type === 'init') {
          const options = dataProducer(rs)
          this.initOptions = options
          this.options = options
          this.myValue = this.multi ?
            this.myValue.map(v => {
              const find = this.initOptions.find(vv => vv.userAccount === v)
              return find && find.email ? find.email : ''
            }) : (() => {
              const find = this.initOptions.find(vv => vv.userAccount === this.myValue)
              return find && find.email ? find.email : ''
            })()
        } else {
          const chosenOps = this.mergeOPtions()
          this.options = _.uniqBy(_.concat([], dataProducer(rs), chosenOps), 'userAccount')
        }

        this.loading = false
      },
      addAccount() {
        const chosen = this.getOptionValue()
        this.onAdd(chosen)
      },
      mergeOPtions(args) {
        const chosenOption = (this.multi ? this.myValue : [this.myValue]).map(v => this.options.find(vv => vv.email === v))
        return this.multi ? chosenOption : []
      },
      clear() {
        this.myValue = this.multi ? [] : ''
      },
      onValueChange(v) {
        this.myValue = v
        this.onChanage(v)
      },
      onClear() {
        this.options = []
      },
      distinct(a, b) {
        let oldArr = a.concat(b)
        let allArr = []
        for (let i = 0; i < oldArr.length; i++) {
          let flag = true
          for (let j = 0; j < allArr.length; j++) {
            if (oldArr[i].email === allArr[j].email) {
              flag = false
            }
          }
          if (flag) {
            allArr.push(oldArr[i])
          }
        }
        return allArr
      },
      getOptionValue() {
        const _ids = this.multi ? this.myValue : [this.myValue]
        return this.distinct(this.options, this.initOptions).filter(v => _ids.findIndex(vv => vv === v.email) !== -1)
        // return _ids
      }
    },
    mounted() {
      if (this.value) {
        this.callStack(this.value, 'init')
      }
    },
    props: {
      onAdd: {
        type: Function,
        default: () => {
        }
      },
      api: {
        type: Function,
        default: () => {
        }
      },
      filter: {
        type: Function,
        default: v => v
      },
      showAdd: {
        type: Boolean,
        default: true
      },
      onChanage: {
        type: Function,
        default: () => {
        }
      },
      value: {
        type: [String, Array]
      },
      collapseTags: {
        type: Boolean,
        default: true
      },
      size: {
        type: String,
        default: 'mini'
      },
      selectDisabled: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      disabled: () => false
      // function() {
      //     return _.isEmpty(this.myValue)
      // }
    },
    watch: {
      value(v) {
        this.myValue = v
      },
      myValue(v) {
        this.$emit('input', v)
      }
    }
  }
</script>
<style scoped>
  .wl-ad-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }

  .mini {
    width: 200px;
  }

  .small {
    width: 300px;
  }

  .wl-green {
    height: 30PX;
    width: 80PX;
    text-align: center;
    border-radius: 0 5px 5px 0 !important;
  }

  .wl-ad-select {
    width: 100%;
  }

  ::v-deep .wl-ad-select.has-right-btn .el-input__inner {
    height: 30PX !important;
    border-radius: 5px 0 0 5px;
    font-size: 12PX;
  }

  ::v-deep .wl-ad-select.no-right-btn .el-input__inner {
    border-radius: 5px;
  }
</style>
